/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, lazy, object, Schema } from '../schema';
import { DirectDebit, directDebitSchema } from './directDebit';

export interface Data5 {
  directDebit: DirectDebit[];
}

export const data5Schema: Schema<Data5> = object({
  directDebit: ['DirectDebit', array(lazy(() => directDebitSchema))],
});
